import { Box, Button, Container, Grid, Typography } from '@mui/material'
import {
    Outlet,
    Route,
    Link as RouterLink,
    Routes,
    useLocation
} from 'react-router-dom'
import SectionErrorBoundary from '@/components/SectionErrorBoundary'
import ArrowLeftIcon from '@/icons/ArrowLeft'

import {
    Browse,
    BrowseButtons,
    BrowseCharts,
    BrowseColors,
    BrowseDetailLists,
    BrowseForms,
    BrowseGridLists,
    BrowseGroupedLists,
    BrowseInputs,
    BrowseModals,
    BrowseQuickStats,
    BrowseTables,
    BrowseTypography
} from '@/routes'

const BrowseLayout = () => {
    const { pathname } = useLocation()
    const urlLastSegment = pathname.slice(pathname.lastIndexOf('/') + 1)
    const isEntry = urlLastSegment === 'browse' || !urlLastSegment
    const title = isEntry
        ? 'Browse features'
        : urlLastSegment
              .split('-')
              .map((word) => word[0].toUpperCase() + word.slice(1))
              .join(' ')

    return (
        <>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    py: 15
                }}
            >
                <Container maxWidth="lg">
                    <Grid alignItems="center" container spacing={3}>
                        <Grid
                            size={{
                                md: 6,
                                xs: 12
                            }}
                        >
                            {!isEntry && (
                                <Button
                                    color="primary"
                                    component={RouterLink}
                                    startIcon={<ArrowLeftIcon />}
                                    sx={{ mb: 3 }}
                                    to="/browse"
                                    variant="text"
                                >
                                    Back to components
                                </Button>
                            )}
                            <Typography color="textPrimary" variant="h1">
                                {title}
                            </Typography>
                            {isEntry && (
                                <Typography
                                    color="textSecondary"
                                    sx={{ mt: 1 }}
                                    variant="body1"
                                >
                                    Browse through over 100 individual
                                    components and over 35 screens
                                </Typography>
                            )}
                        </Grid>
                        <Grid
                            sx={{
                                display: {
                                    md: 'flex',
                                    xs: 'none'
                                },
                                justifyContent: 'center'
                            }}
                            size={{
                                md: 6,
                                xs: 12
                            }}
                        >
                            <img alt="Components" src="/browse/hero.svg" />
                        </Grid>
                    </Grid>
                </Container>
            </Box>
            <SectionErrorBoundary label="browse-content">
            <Routes>
                <Route path="/" element={<Browse />} />
                <Route path="buttons" element={<BrowseButtons />} />
                <Route path="inputs" element={<BrowseInputs />} />
                <Route path="charts" element={<BrowseCharts />} />
                <Route path="colors" element={<BrowseColors />} />
                <Route
                    path="data-display/detail-lists"
                    element={<BrowseDetailLists />}
                />
                <Route
                    path="data-display/quick-stats"
                    element={<BrowseQuickStats />}
                />
                <Route path="data-display/tables" element={<BrowseTables />} />
                <Route path="forms" element={<BrowseForms />} />
                <Route path="modals" element={<BrowseModals />} />
                <Route
                    path="lists/grouped-lists"
                    element={<BrowseGroupedLists />}
                />
                <Route path="lists/grid-lists" element={<BrowseGridLists />} />
                <Route path="typography" element={<BrowseTypography />} />
            </Routes>
            </SectionErrorBoundary>
        </>
    )
}

export default BrowseLayout
